import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';
import Input from 'af-fields/Input';

import WorkRequestUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn2, formSectionClassColumn4, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

const EnvironmentalProtectionSection: React.FC = () => {
	const checkboxStyle = React.useMemo(() => [formSectionClassColumn2, styles['work-request-form__tab-content__form-section__row__centered-column']].join(' '), []);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Environmental Protection"
				tooltip="Environmental considerations and protective measures required for this job, addressing potential impacts on water, wetlands, drainage systems, and sensitive ecological areas."
			/>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="waterOrWetlands"
						label="Water/Wetlands"
						name={WorkRequestUpsertFM.getAttributeName('waterOrWetlands')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="waterOrWetlandsDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('waterOrWetlandsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="stormDrain"
						label="Storm Drain"
						name={WorkRequestUpsertFM.getAttributeName('stormDrain')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="stormDrainDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('stormDrainDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="bypassPumping"
						label="Bypass Pumping"
						name={WorkRequestUpsertFM.getAttributeName('bypassPumping')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="byPassPumpingDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('bypassPumpingDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="sensitiveEnvironment"
						label="Sensitive Environment"
						name={WorkRequestUpsertFM.getAttributeName('sensitiveEnvironment')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="sensitiveEnvironmentDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('sensitiveEnvironmentDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(EnvironmentalProtectionSection);
